// const PROXY = 'http://localhost:8080'
const PROXY = ''

export default PROXY